export const POSTS_LIMIT_PER_REQUEST = 100;

export const POSTS_SORTING_PARAMETER_KEYS = {
    createdAt: 'date',
    platformId: 'platform',
    mediaTypeIds: 'mediaType',
    impressions: 'impressions',
    videoViews: 'videoViews',
    engagements: 'engagements',
    fullMediaValue: 'fmv',
};

export const NAME_ACCESSOR_COLUMNS = {
    DATE: {
        name: 'Date',
        accessor: 'createdAt',
    },
    PLATFORM: {
        name: 'Platform',
        accessor: 'platformId',
    },
    MEDIA_TYPE: {
        name: 'Media Type',
        accessor: 'mediaTypeId',
    },
    IMPRESSIONS: {
        name: 'Impressions',
        accessor: 'impressions',
    },
    VIDEO_VIEWS: {
        name: 'Video Views',
        accessor: 'videoViews',
    },
    ENGAGEMENTS: {
        name: 'Engagements',
        accessor: 'engagements',
    },
    FMV: {
        name: 'FMV',
        accessor: 'fullMediaValue',
    },
};

export const ALL_POSTS_TABS = {
    ALL_POSTS: 'All Posts',
    CAMPAIGNS: 'Campaigns',
};
